import { useFeatureFlag } from "@src/features/app/hooks/useFeatureFlag";
import { Ff } from "@src/types.generated";

/**
 * The builder's canvas tools (screen media layout and on-screen crop, the
 * glass selection pill and link bubble, the regrouped screen ⋯ menu and its
 * shortcuts) ship with the redesigned content pages, under the same flag.
 * scadmin refuses media layout edits without it too.
 */
const useBuilderCanvasTools = (): boolean =>
  useFeatureFlag(Ff.LibraryItemOverviewTab);

export default useBuilderCanvasTools;
